/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { AidModelCoaDto, AidModelCoaUpdateRequest } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates COA expenses (only currentYearAmount) and includeRequiredFees.
 * @summary Update COA
 */
export const updateAidModelCoa = (
  oktaUserId: string,
  modelId: number,
  id: number,
  aidModelCoaUpdateRequest: BodyType<AidModelCoaUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelCoaDto>(
    {
      url: `/api/${oktaUserId}/aid-model/${modelId}/coa/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelCoaUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateAidModelCoaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAidModelCoa>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<AidModelCoaUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAidModelCoa>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<AidModelCoaUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateAidModelCoa'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAidModelCoa>>,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<AidModelCoaUpdateRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, id, data } = props ?? {};

    return updateAidModelCoa(oktaUserId, modelId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAidModelCoaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAidModelCoa>>
>;
export type UpdateAidModelCoaMutationBody = BodyType<AidModelCoaUpdateRequest>;
export type UpdateAidModelCoaMutationError = ErrorType<unknown>;

/**
 * @summary Update COA
 */
export const useUpdateAidModelCoa = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAidModelCoa>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        id: number;
        data: BodyType<AidModelCoaUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAidModelCoa>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<AidModelCoaUpdateRequest>;
  },
  TContext
> => {
  return useMutation(getUpdateAidModelCoaMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns COA for the aid model. Creates from copy or Databricks if not yet present.
 * @summary Get COA
 */
export const getAidModelCoa = (
  oktaUserId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelCoaDto[]>(
    {
      url: `/api/${oktaUserId}/aid-model/${modelId}/coa`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetAidModelCoaQueryKey = (
  oktaUserId: string,
  modelId: number
) => {
  return [`/api/${oktaUserId}/aid-model/${modelId}/coa`] as const;
};

export const getGetAidModelCoaQueryOptions = <
  TData = Awaited<ReturnType<typeof getAidModelCoa>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModelCoa>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAidModelCoaQueryKey(oktaUserId, modelId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAidModelCoa>>> = ({
    signal,
  }) => getAidModelCoa(oktaUserId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAidModelCoa>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAidModelCoaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAidModelCoa>>
>;
export type GetAidModelCoaQueryError = ErrorType<unknown>;

export function useGetAidModelCoa<
  TData = Awaited<ReturnType<typeof getAidModelCoa>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModelCoa>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelCoa>>,
          TError,
          Awaited<ReturnType<typeof getAidModelCoa>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelCoa<
  TData = Awaited<ReturnType<typeof getAidModelCoa>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModelCoa>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAidModelCoa>>,
          TError,
          Awaited<ReturnType<typeof getAidModelCoa>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAidModelCoa<
  TData = Awaited<ReturnType<typeof getAidModelCoa>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModelCoa>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get COA
 */

export function useGetAidModelCoa<
  TData = Awaited<ReturnType<typeof getAidModelCoa>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAidModelCoa>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAidModelCoaQueryOptions(
    oktaUserId,
    modelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
